import * as React from "react"
import { IconProps } from "./utils"

export function MDIcon({ height = 24, width = 24 }: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 39 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.74286 23.5429H35.5429C37.0286 23.5429 38.1714 22.2857 38.1714 20.8V2.74286C38.1714 1.25714 36.9143 0 35.4286 0H2.74286C1.25714 0 0 1.25714 0 2.74286V20.8C0 22.2857 1.25714 23.5429 2.74286 23.5429ZM1.82036 2.70069C1.82036 2.24355 2.2775 1.78641 2.73464 1.78641H35.4204C35.8775 1.78641 36.3346 2.12927 36.3346 2.70069V20.7578C36.3346 21.215 35.9918 21.6721 35.4204 21.6721H2.73464C2.2775 21.6721 1.82036 21.3293 1.82036 20.7578V2.70069ZM5.46108 17.9307V5.35922H9.11822L12.7754 9.93065L16.4325 5.35922H20.0896V17.9307H16.4325V10.7307L12.7754 15.3021L9.11822 10.7307V17.9307H5.46108ZM22.8682 11.8735L28.354 17.9307L33.8397 11.7592H30.1825V5.35922H26.5254V11.8735H22.8682Z"
        fill="black"
      />
    </svg>
  )
}
